import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import CART_ITEM from '../../constants/cartItems';
import AlbumPrintPackageCartItem from './AlbumPrintPackageCartItem';
import AlbumFolderSubscriptionCartItem from './AlbumFolderSubscriptionCartItem';
import AlbumSubscriptionCartItem from './AlbumSubscriptionCartItem';
import AlbumCustomPrintCartItem from './AlbumCustomPrintCartItem';
import DigitalDownloadCartItem from './DigitalDownloadCartItem';
import { cartItemUpdate, onCartItemRemove } from '../../redux/checkoutActions';
import IndividualPrintCartItem from './IndividualPrintCartItem';
import LegacyPrintCartItem from './LegacyPrintCartItem';
import PhotoDownloadCartItem from './PhotoDownloadCartItem';
import {
  closeModal as closeModalAction,
  openModal as openModalAction,
} from '../../../../actions/modal-actions';
import PrintProductCartItem from './PrintProductCartitem';
import PhotoPricingPrintProductCartItem from './PhotoPricingPrintProductCartItem';
import PurchasedPrintPackageCartItem from './PurchasedPrintPackageCartItem';
import PurchasedPhotoPricingPrintProductCartItem from './PurchasedPhotoPricingPrintProductCartItem';
import PurchasedDigitalDownloadCartItem from './PurchasedDigitalDownloadCartItem';
import PurchasedCustomPrintCartItem from './PurchasedCustomPrintCartItem';
import DigitalBundleCartItem from './DigitalBundleCartItem';

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(CART_ITEM)),
  }).isRequired,
  pricing: PropTypes.shape({
    price: PropTypes.object,
    discount_price: PropTypes.object,
  }),
  loading: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const CheckoutCartItem = ({
  item,
  pricing,
  loading,
  onRemove,
  onUpdate,
  openModal,
  closeModal,
  watermarkSettings,
}) => {
  if (item.type === CART_ITEM.ALBUM_FOLDER_SUBSCRIPTION) {
    return (
      <AlbumFolderSubscriptionCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.ALBUM_SUBSCRIPTION) {
    return (
      <AlbumSubscriptionCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.ALBUM_CUSTOM_PRINT) {
    return (
      <AlbumCustomPrintCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PURCHASED_CUSTOM_PRINT) {
    return (
      <PurchasedCustomPrintCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.ALBUM_PRINT_PACKAGE) {
    return (
      <AlbumPrintPackageCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        openModal={openModal}
        closeModal={closeModal}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PURCHASED_PRINT_PACKAGE) {
    return (
      <PurchasedPrintPackageCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        openModal={openModal}
        closeModal={closeModal}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.DIGITAL_DOWNLOAD) {
    return (
      <DigitalDownloadCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PURCHASED_DIGITAL_DOWNLOAD) {
    return (
      <PurchasedDigitalDownloadCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PHOTO_DOWNLOAD) {
    return (
      <PhotoDownloadCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.INDIVIDUAL_PRINT) {
    return (
      <IndividualPrintCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.LEGACY_PRINT) {
    return (
      <LegacyPrintCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PRINT_PRODUCT) {
    return (
      <PrintProductCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PHOTO_PRICING_PRINT_PRODUCT) {
    return (
      <PhotoPricingPrintProductCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.PURCHASED_PHOTO_PRICING_PRINT_PRODUCT) {
    return (
      <PurchasedPhotoPricingPrintProductCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  if (item.type === CART_ITEM.DIGITAL_BUNDLE) {
    return (
      <DigitalBundleCartItem
        item={item}
        pricing={pricing}
        loading={loading}
        onRemove={onRemove}
        onUpdate={onUpdate}
        watermarkSettings={watermarkSettings}
      />
    );
  }

  return null;
};

CheckoutCartItem.propTypes = propTypes;

const mapDispatchToProps = {
  onRemove: onCartItemRemove,
  onUpdate: cartItemUpdate,
  openModal: openModalAction,
  closeModal: closeModalAction,
};

export { CheckoutCartItem as CheckoutCartItemComponent };

export default compose(connect(null, mapDispatchToProps))(CheckoutCartItem);
